(function() {
    if (window.bundleSubscriptionLoaded) return;
    window.bundleSubscriptionLoaded = true;

// 🔥 ACTIVE VARIANT INPUT
// `.bundle_item` (quantity/bundle selector radios) only exists when that
// block is added to the page. Picking the source by `.default_variant`'s
// static has_only_default_variant flag - like the call sites here used to -
// is wrong whenever a product has multiple variants but no bundle selector
// block: `.bundle_item:checked` is then empty, and every price/id field read
// from it becomes NaN/undefined (onetime_reg, winner_text, bundle-price-box
// all break). Always prefer the actual checked bundle item and only fall
// back to `.default_variant` when one truly isn't present.
function getPriceInput() {
    var bundleChecked = $('.bundle_item:checked');
    return bundleChecked.length ? bundleChecked : $('.default_variant');
}

$(document).ready(function(){

    // Initialize Bundle V2
    if (window.bundleV2 && typeof window.bundleV2.init === 'function') {
        window.bundleV2.init();
    }

    // 🔥 FINAL PRICE BOX FUNCTION
    function updateBundlePriceBox(price, compare, discount, plan) {

        var $box = $('.bundle-price-box');
        if ($box.length === 0) return;

        price = parseFloat(price);
        discount = parseFloat(discount);

        function format(val) {
            return currency + val.toFixed(2).replace('.', ',');
        }

        var isSubscription = plan === undefined ? true : (plan == 1 || plan === '1');
        let finalPrice = (isSubscription && discount > 0) ? discount : price;

        // Reuse the exact same compare-price calculation used for the Claim
        // Deal button and Abonnement row (updateComparePrice), instead of a
        // separate parallel calculation here - so the top price box can
        // never show a different number than the CTA button.
        var comparePricesForBox = updateComparePrice();
        var realCompare = isSubscription ? comparePricesForBox.subscription : comparePricesForBox.onetime;

        // $box.find('.current-price').text(format(finalPrice));




        // from here 

if (
    window.directCheckoutTemplate &&
    window.directCheckoutTemplate.suffix === '8-cadeaus-3-javy-new'
) {
    var selected = $('.bundle_item:checked');
    var qty = 1;
    var totalShots = 12;

    if (selected.length) {
        var bundle = selected.closest('.bundle-item');
        var title = bundle.find('.bundle-title').text().trim();

        var match = title.match(/\d+/);
        if (match) {
            qty = parseInt(match[0], 10);
        }

        // Only apply the special calculation to the 5+3 FREE bundle
        if (title.includes('5+3')) {
            totalShots = (8 * 12) + 7; // 103 shots
        } else {
            totalShots = qty * 12;
        }
    }

    var perShotPrice = finalPrice / totalShots;
    var ceiledPerShotPrice = Math.ceil(perShotPrice * 100) / 100
    var formattedPerShotPrice = format(ceiledPerShotPrice == 0.98 ? 0.97 : ceiledPerShotPrice)

    $box.find('.current-price').html(
        `${formattedPerShotPrice} <span>per shot</span>`
    );

} else {
    $box.find('.current-price').text(format(finalPrice));
}
        // here developer work 





        // ✅ Always show best-seller badge
        $box.find('.best-seller').text('Bestseller').show();

        if(realCompare > 0 && realCompare > finalPrice) {

            let saveAmount = (realCompare - finalPrice).toFixed(0);

            $box.find('.compare-price')
                .text(format(realCompare))
                .show();

            $box.find('.save-badge')
                .text('Bespaar ' + currency + saveAmount)
                .show();

        } else {
            $box.find('.compare-price').hide();
            $box.find('.save-badge').hide();
        }
    }

    // 🔁 Bundle change
    $('.bundle_item').on('change', function(){
        var price = $(this).data('price');
        var compare = $(this).data('compare');
        var discount = $(this).data('discount');
        var variant_id = $(this).data('vid');
        var plan = $('.input_plan:checked').val();
        var plan_id = $('.select-delivery-time option:selected').val();

        priceUpdate(price, compare, discount, variant_id, plan, plan_id);
        updateBundlePriceBox(price, compare, discount, plan);

        var bundleName = $(this).attr('name');
        if (bundleName === 'bundle') {
            var v2Input = document.querySelector('input[name="bundle-v2-selection"][value="' + variant_id + '"]');
            if (v2Input && !v2Input.checked) {
                v2Input.checked = true;
            }
        }

        if (window.bundleV2 && typeof window.bundleV2.updateGiftAvailability === 'function') {
            window.bundleV2.updateGiftAvailability();
        }
    });

    // 🔁 Subscription change
    $('.input_plan').on('change', function(){
        var input = getPriceInput();

        var price = input.data('price');
        var compare = input.data('compare');
        var discount = input.data('discount');
        var variant_id = input.data('vid');
        var plan = $(this).val();
        var plan_id = $('.select-delivery-time option:selected').val();

        priceUpdate(price, compare, discount, variant_id, plan, plan_id);
        updateBundlePriceBox(price, compare, discount, plan);
    });

    $('.select-delivery-time').on('change', function(){
        var id = $(this).val();
        $('#selling_plan').val(id);
    });

    // 🔁 Prevent the page from jumping when a bundle card is selected.
    // The radio itself is visually hidden (.bundle-item input { opacity: 0 }),
    // so a plain label click lets the browser auto-focus it and, if it
    // judges the input isn't fully in view, scroll the page to reveal it.
    // Handle the selection ourselves and focus with preventScroll instead.
    document.addEventListener('click', function (e) {
        var label = e.target.closest('.bundle-label');
        if (!label) return;

        var input = document.getElementById(label.getAttribute('for'));
        if (!input || input.disabled) return;

        e.preventDefault();
        if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        input.focus({ preventScroll: true });
    });

    // 🔥 INITIAL LOAD FIX (FINAL)
    $(window).on('load', function(){

        var input = getPriceInput();

        if (input.length) {
            var price = input.data('price');
            var compare = input.data('compare');
            var discount = input.data('discount');
            var variant_id = input.data('vid');

            var plan = $('.input_plan:checked').val();
            var plan_id = $('.select-delivery-time option:selected').val();

            // ✅ Fix: ensures winner_text loads correctly
            priceUpdate(price, compare, discount, variant_id, plan, plan_id);

            // ✅ Keep price box in sync
            updateBundlePriceBox(price, compare, discount, plan);
        }
    });

});


// 🔥 PRICE UPDATE
function priceUpdate(price, compare, discount, variant_id, plan, plan_id) {

    discount = parseFloat(discount).toFixed(2).replace('.', ',');
    price = parseFloat(price).toFixed(2).replace('.', ',');

    function dropZeroCents(str) {
        return str.slice(-3) === ',00' ? str.slice(0, -3) : str;
    }

    $('.subs_price').text(currency + dropZeroCents(discount));

    // .prev_price / .onetime_prev_price are set below by updateComparePrice(),
    // which splits gift-inclusive (subscription) from plain (one-time) compare price.

    var _noDecimals = document.querySelector('.onetime-price-block[data-no-decimals="true"]');
    var _onetimePrice = _noDecimals ? (currency + dropZeroCents(price)).replace(/[,\.]\d{2}$/, '') : currency + dropZeroCents(price);
    var _customPriceBlock = document.querySelector('.onetime-price-block[data-custom-price]');
    var _usedCustomPrice = false;
    if (_customPriceBlock) {
        var _bundleSelect = (_customPriceBlock.dataset.bundleSelect || '').trim();
        var _radios = Array.from(document.querySelectorAll('input[name="bundle"]'));
        var _checkedIdx = _radios.findIndex(function(r){ return r.checked; });
        var _targetIdx = { first: 0, second: 1, third: 2, fourth: 3, fifth: 4, sixth: 5, last: _radios.length - 1 }[_bundleSelect];
        if (_checkedIdx !== -1 && _checkedIdx === _targetIdx) {
            $('.onetime_reg').text(_customPriceBlock.dataset.customPrice);
            _usedCustomPrice = true;
        }
    }
    if (!_usedCustomPrice) {
        $('.onetime_reg').text(_onetimePrice);
    }
    $('#product_id').val(variant_id);

    var isSubscriptionPlan = (plan == 1 || plan === '1');

    if(isSubscriptionPlan) {
        $('#selling_plan').val(plan_id);
        $('#winner_text').text(currency + dropZeroCents(discount));
    } else {
        $('#selling_plan').val('');
        $('#winner_text').text(currency + dropZeroCents(price));
    }

    var comparePrices = updateComparePrice();

    // The floating "winner" summary mirrors whatever compare price is shown
    // on the currently selected bundle card (same source as the price box),
    // so it can't drift from what the card displays or go blank if the
    // checked-radio lookup misses. Falls back to the subscription figure
    // (compare_at_price, or regular price, plus gift values) while
    // subscribed - same as the Abonnement row and top price box - or the
    // plain compare_at_price for one-time purchase.
    var $selectedCardForWinner = $('.bundle_item:checked').closest('.bundle-item');
    var winnerCardText = $selectedCardForWinner.find('.bundle-prev-price').first().text();
    var winnerCompareValue = parseFloat((winnerCardText || '').replace(/[^\d,.]/g, '').replace(',', '.')) || 0;
    if (winnerCompareValue === 0) {
        winnerCompareValue = isSubscriptionPlan ? comparePrices.subscription : comparePrices.onetime;
    }
    // Only show the strikethrough when it's actually higher than the price
    // being displayed - otherwise (no real compare_at_price) the fallback
    // equals the current price and shows a meaningless "was €X now €X".
    var currentDisplayedPrice = isSubscriptionPlan
        ? parseFloat(discount.replace(',', '.'))
        : parseFloat(price.replace(',', '.'));
    if (winnerCompareValue > 0 && winnerCompareValue > currentDisplayedPrice) {
        $('#winner_text_compare').text(comparePrices.format(winnerCompareValue)).show();
    } else {
        $('#winner_text_compare').hide();
    }

    if (typeof updateBundlePriceBox === 'function') {
        updateBundlePriceBox(price.replace(',', '.'), compare, discount.replace(',', '.'), plan);
    }
}


// 🔥 ADD TO CART (UNCHANGED)
$(document).ready(function(){
    $('.addToCart').on('click', function(e){
        // This handler owns the add-to-cart flow end-to-end (AJAX POST
        // below + opens the cart drawer). Buttons carrying this class are
        // often type="submit" bound to a product form (directly, or via
        // form="..."), so without this the form's own native/JS submit
        // would ALSO fire and add the same item a second time.
        e.preventDefault();

        console.log("This is testing csrt");

        let plan = $('.input_plan:checked').val();
        var items = [];
        var mainProductId = $('#product_id').val();
        var mainPlan = $('#delivery_time').val();

        var gift = 0;
        var selectedVariantId = null;
        var isBundleV2Active = false;

        var bundleV2Input = document.querySelector('input[name="bundle-v2-selection"]:checked');

        if (bundleV2Input) {
            gift = bundleV2Input.getAttribute('data-gift');
            selectedVariantId = bundleV2Input.value;
            isBundleV2Active = true;
        } else {
            var oldBundleInput = $('.bundle_item:checked');
            if (oldBundleInput.length) {
                gift = oldBundleInput.data('gift');
                selectedVariantId = oldBundleInput.data('vid');
                isBundleV2Active = false;
            }
        }


        items.push({
            id: mainProductId,
            quantity: 1,
            ...(plan == 1 && { selling_plan: mainPlan })
        });

        if(plan == 1) {
            $('.gift-item').each(function () {
                let giftId = $(this).data('id');
                if(giftId) items.push({ id: giftId, quantity: 1 });
            });    
        }

        if(gift == 1 && selectedVariantId) {
            if (isBundleV2Active) {
                $('.gift-v2-item').each(function () {
                    if ($(this).hasClass('disable')) return;
                    var giftVariants = $(this).attr('data-variants');
                    if (giftVariants && giftVariants.split(',').includes(selectedVariantId)) {
                        let giftId = $(this).data('id');
                        if(giftId) items.push({ id: giftId, quantity: 1 });
                    }
                });
            } else {
                $('.variant_gift').each(function () {
                    if ($(this).hasClass('gift-v2-item')) return;
                    // 8-gift bundle: locked gifts aren't included in the selected deal
                    if ($(this).hasClass('is-locked')) {
                        console.warn('[gifts] skipped (locked):', $(this).find('h3').text());
                        return;
                    }
                    let giftId = $(this).data('id');
                    if(giftId) {
                        items.push({ id: giftId, quantity: 1 });
                    } else {
                        console.warn('[gifts] skipped (no data-id, gift entry has no product):', $(this).find('h3').text());
                    }
                });
            }
        }

        $('.upsell_item').each(function () {
            let id = $(this).val();
            if(id != '') items.push({ id: id, quantity: 1 });
        });



        // Only tag with _bundle_id if more than 1 item
        if (items.length > 1) {
            const bundleId = 'bundle_' + Date.now();
            items.forEach(function(item) {
                item.properties = item.properties || {};
                item.properties._bundle_id = bundleId;
            });
        } else {
            // Single item — strip the _bundle_id that was already set above
            items.forEach(function(item) {
                if (item.properties) {
                    delete item.properties._bundle_id;
                    if (Object.keys(item.properties).length === 0) {
                        delete item.properties;
                    }
                }
            });
        }

        console.log("items list " + items);

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ items: items }),
            contentType: 'application/json',
            dataType: 'json'

        }).done(function(response) {

    // Direct checkout only for this template
    if (
        window.directCheckoutTemplate &&
        window.directCheckoutTemplate.suffix === "puur-direct-to-checkout"
    ) {
        window.location.href = "/checkout";
        return;
    }

    document.dispatchEvent(
        new CustomEvent("gOpenCart", {
            detail: { fromAddToCart: true }
        })
    );

});
        // }).done(function(response) {
        //     document.dispatchEvent(new CustomEvent("gOpenCart", { detail: { fromAddToCart: true } }));
        // });
    });

});


// 🔥 COMPARE PRICE
function updateComparePrice() {

    var $mainBlock = getPriceInput();

    var basePrice = parseFloat($mainBlock.data('price'));
    var comparePrice = parseFloat($mainBlock.data('compare'));
    var discountPrice = parseFloat($mainBlock.data('discount'));
    var isGiftVariant = $mainBlock.data('gift') == 1;

    // One-time purchase: always the variant's own compare_at_price as saved
    // in the backend — no gift items added.
    var onetimeComparePrice = (comparePrice > 0) ? comparePrice : basePrice;

    // Subscription: the same backend compare_at_price plus all configured
    // gift item values - but only for the variant the gifts are actually
    // attached to (data-gift="1", from the bundle_select metafield match).
    // Other variants have no free gifts to add.
    var giftTotal = 0;
    if (isGiftVariant) {
        $('.gift-item').each(function () {
            var giftPrice = parseFloat($(this).data('price'));
            if (!isNaN(giftPrice)) giftTotal += giftPrice;
        });
    }
    var subscriptionComparePrice = onetimeComparePrice + giftTotal;

    function formatEuro(value) {
        var formatted = value.toFixed(2).replace('.', ',');
        if (formatted.slice(-3) === ',00') formatted = formatted.slice(0, -3);
        return currency + formatted;
    }

    var save = Math.round(subscriptionComparePrice - discountPrice);

    $('.prev_price').text(formatEuro(subscriptionComparePrice));
    // Hide the one-time strikethrough when the variant has no real compare_at_price
    // — otherwise it shows "was €X now €X" with no actual discount.
    $('.onetime_prev_price').toggle(comparePrice > 0).text(formatEuro(onetimeComparePrice));
    $('.subscription-savings').text(currency + save + ' KORTING');

    return { onetime: onetimeComparePrice, subscription: subscriptionComparePrice, format: formatEuro };
}

$(document).ready(function () {
    updateComparePrice();
});

})();